import cancelPaymentRequestAction from '../services/paymentRequest/cancelPaymentRequestAction';

type CancelActionParams = {
  id: string,
  reasonCode?: io.flow.v0.enums.PaymentFailureCode,
  data?: any;
};

export default function cancelAction(params: CancelActionParams):
Promise<io.flow.internal.v0.models.InternalPaymentRequest> {
  return cancelPaymentRequestAction(params);
}
